loadJs = (urls=[], cb=_.noop, onLoad = false) ->
  urls = [urls] unless _.isArray urls
  load = -> $.when.apply(window, (_.map urls, (url) -> $.ajax {url, dataType: 'script', cache: yes})).done cb
  return $(window).load(load) if onLoad
  load()

module.exports =
  getLegalDisclaimerText: (env) ->
    termsOfUse = I18n.t 'js.modules.applepay.terms_of_use'
    privacyStatement = I18n.t 'js.modules.applepay.privacy_statement'
    I18n.t "js.modules.applepay.#{env}.legal_disclaimer",
      termsOfUse: '<a href="/terms">' + termsOfUse + '</a>'
      privacyStatement: '<a href="/privacy">' + privacyStatement + '</a>'
  lazyLoadJs: (urls, fn, onLoad) -> loadJs urls, fn, onLoad



// WEBPACK FOOTER //
// ./modules/applepay/frontend/helpers.coffee